import type { FinanceRequestDetail } from '@/services/financeService'

export const FINANCE_STATUS_CONTRATO_ASSINADO = 'CONTRATO_ASSINADO' as const

export function isSignedContractUploadAllowed(detail: Pick<FinanceRequestDetail, 'type' | 'status'>) {
  if (detail.type !== 'C4_CONTRATO_AGRADA') return true
  return detail.status === FINANCE_STATUS_CONTRATO_ASSINADO || detail.status === 'CONCLUIDO'
}

export function showSignedContractSection(detail: FinanceRequestDetail) {
  if (!detail.project?.id) return false
  return isSignedContractUploadAllowed(detail)
}
